<template>
    <Multiselect id="ss_employee" class="multiselect-locations multiselect-small" v-model="employeeSelected" mode="single"
        :close-on-select="true" :searchable="true" :create-option="false" :object="true" :options="employeesSelectable"
        :hideSelected="false" locale="de" fallback="en" @clear="clearedEmployeeSingleselect" placeholder="Mitarbeiter auswählen"
        @deselect="deselectedEmployeeSingleselect" @select="selectSingleselect"  />
</template>

<style>
.multiselect-locations {
    z-index: 120;
}
</style>


<script>

import Multiselect from '@vueform/multiselect';

export default {

    setup() {
    },
    name: "SingleSelectEmployees",
    components: {
        Multiselect,
    },
    props: {
        employees: Object,
    },
    emits:['selectedemployeeChanged'],
    data() {
        return {
            optionSelected: "",
            employeeSelected: [],
        }
    },
    mounted() {
       
    },
    watch: {
        employeeSelected(newValue, oldValue) {
            this.$emit('selectedemployeeChanged',this.employeeSelected);
        }
    },
    computed: {
        employeesSelectable() {
            var items = [];
            if (this.employees) {
                this.employees.forEach(element => {
                    const employee = {
                        value: element.id,
                        label: { en: element.lastname + ', ' + element.forename },
                    };
                    items.push(employee);
                });
            }
            return items;
        },
    },
    methods: {
        clearedEmployeeSingleselect() {
            this.employersSelected = []; 

        },
        deselectedEmployeeSingleselect() {
            if (this.employeeSelected.length == 0) {
                this.employeeSelected = [];
            }
        },
        selectSingleselect() {
            if (this.employeeSelected.length > 0) {
                const allOptionSelected = this.employeeSelected.find((employeeSelected) => employeeSelected.value == []);
                if (allOptionSelected != null) {
                    this.employeeSelected = this.employeeSelected.filter((employeeSelected) => employeeSelected.value != 9999);
                }
            }
        },
    }
}

</script>
<style scoped>
.multiselect-small {
    --ms-font-size: 0.8rem;
}
</style>>

